import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { errors, paxRoute, sessionRequired, staffAuth } from "../../common";
import { LedgerReportParams, LedgerReportQuery, LedgerReportResponse } from "./schemas";

export const getLedgerReport = oc
  .meta(
    paxRoute({ auth: staffAuth("credits.view"), minimumTier: null, cost: "read" }),
    openapi({
      method: "GET",
      path: "/api/accounting/v1alpha1/reports/{report}",
      operationId: "accounting.reports.get",
      summary: "Read a ledger report.",
      description:
        "Returns system account flows or journal totals over a named range ending at the latest hour every report has rolled up, per hour or day and in total.",
      inputStructure: "detailed",
      successDescription: "The report over the range, and the window it covers.",
    }),
  )
  .errors({ ...errors.badRequest, ...sessionRequired, ...errors.forbidden })
  .input(z.object({ params: LedgerReportParams, query: LedgerReportQuery }))
  .output(LedgerReportResponse);
